import { render, staticRenderFns } from "./TemplateAddDialog.vue?vue&type=template&id=6e8848ce&scoped=true&"
import script from "./TemplateAddDialog.vue?vue&type=script&lang=ts&"
export * from "./TemplateAddDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateAddDialog.vue?vue&type=style&index=0&id=6e8848ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8848ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
